import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SpotCountUpdatePaymentModalComponent } from '../spot-count-update-payment-modal/spot-count-update-payment-modal.component';
import { PaymentStatusForMessage } from '@core/models/api-response.model';
import { DECREASE_SPOT_MSG, INCREASE_SPOT_MSG, SPOT_INCEASE_DECREASE_SUCCSESS_MSG, SpotUpdateType, USER_ROLES } from '@shared/constant/shared.constant';
import { SpotCountUpdateSuccessModalComponent } from '../spot-count-update-success-modal/spot-count-update-success-modal.component';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { SpotCountUpdateService } from '@core/services/spot-count-update.service';

@Component({
  selector: 'app-spot-update-confimation-modal',
  templateUrl: './spot-update-confimation-modal.component.html',
  styleUrls: ['./spot-update-confimation-modal.component.scss']
})
export class SpotUpdateConfimationModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  spotChangeType: number;
  checkAvalitityData: any;
  bookingId: string = '';
  decreaseSpotFrom: number;
  spotUpdateType: number;
  noOfSlots: number;
  paymentStatusEnum = PaymentStatusForMessage;
  userRoles = USER_ROLES;
  groupUserBookingDetailsRoute:string = '';
  spotUpdateTypeEnum = SpotUpdateType;
  confirmationMessage: string;
  nextBillingCycleChecks: boolean = false;
  noteMessage: string;
  
  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly spotCountUpdateService: SpotCountUpdateService,
    private readonly toastService: ToastService,
    private readonly dialogControlService: DialogControlService,
  ) { }

  ngOnInit(): void {
    this.spotChangeType = this.config?.data?.spotChnageType;
    this.checkAvalitityData = this.config?.data.data;
    this.bookingId = this.config?.data?.bookingId
    this.decreaseSpotFrom = this.config?.data?.decreaseSpotFrom;
    this.spotUpdateType = this.config?.data?.spotUpdateType;
    this.noOfSlots = this.config?.data?.noOfSlots;
    this.nextBillingCycleChecks = this.config?.data?.nextBillingCycleChecks;
    this.confirmationMessage =
      this.config?.data?.nextBillingCycleChecks && this.spotUpdateType === this.spotUpdateTypeEnum.Increase
      ? INCREASE_SPOT_MSG
      : DECREASE_SPOT_MSG;
    this.noteMessage = this.config?.data?.data?.message;
  }

  onConfirm(): void {
    if (this.spotUpdateType === 1) {
      if (this.checkAvalitityData.bookingPaymentStatus === this.paymentStatusEnum.Completed && !this.nextBillingCycleChecks) {
        this.closeDialog();
        this.openSoptUpadtePaymentModal(this.checkAvalitityData);
        return;
      }
      this.increaseGroupBookingSpot(this.checkAvalitityData);
      return;
    }
    return this.decreaseGroupBookingSpot();
  }

  decreaseGroupBookingSpot(): void {
    let request = {
      bookingId: this.bookingId,
      noOfSlots: this.noOfSlots,
      spotUpdateType: this.spotUpdateType,
      decreaseSpotFrom: this.decreaseSpotFrom,
      forceUpdateNextBilling: this.nextBillingCycleChecks
    }
    this.spotCountUpdateService.decreaseGroupBookingSpot(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.closeDialog();
        this.openSuccessModal(response);
      }, error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error?.error?.message);
      }
    })
  }

  openSoptUpadtePaymentModal(data): void {
    this.dialogControlService.openDialog(
      SpotCountUpdatePaymentModalComponent,
      {
        styleClass: 'pay-repay',
        data: {
          data: data,
          bookingId: this.bookingId,
          noOfSlots: this.noOfSlots,
          spotUpdateType: this.spotUpdateType,
          decreaseSpotFrom: this.decreaseSpotFrom
        },
      }
    )
  }

  increaseGroupBookingSpot(product): void {
    let request = {
      bookingId: this.bookingId,
      noOfSlots: this.noOfSlots,
      spotUpdateType: this.spotUpdateType,
      increaseSpotFrom: this.decreaseSpotFrom,
      paymentMethod: product.paymentMethodType,
      isPreferredPaymentMethod: null,
      preferredPaymentMethodId: null,
      forceUpdateNextBilling: this.nextBillingCycleChecks
    };
    this.spotCountUpdateService.increaseGroupBookingSpot(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.closeDialog();
        this.openSuccessModal(response);
      }, error: (error) => {
        const errorMessage = error?.error?.message || '';
        this.toastService.showToastMessage('error', 'Error', errorMessage);
      }
    })
  }

  openSuccessModal(bookingDetail): void {
    let bodyText: string = SPOT_INCEASE_DECREASE_SUCCSESS_MSG;
    this.dialogControlService.openDialog(SpotCountUpdateSuccessModalComponent, {
      width: '20%',
      data: {
        bookingId: this.bookingId,
        bodyText: this.nextBillingCycleChecks ? bookingDetail.message: bodyText,
        heading: '',
        isSpotUpdate:true
      },
    });
  }
  
  closeDialog(): void {
    this.ref.close();
  }
}
